module.exports = __webpack_public_path__ + "f69e37bb756a6a47c2ef5ff6fe0d4c23.svg";